import Header from "../components/Header";
import Hero from "../components/Hero";
import CoreValues from "../components/CoreValues";
import MissionVision from "../components/MissionVision";
import Audience from "../components/Audience";
import AboutSections from "../components/AboutSections";
import GoogleReviews from "../components/GoogleReviews";
import News from "../components/News";
import CTABand from "../components/CTABand";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <CoreValues />
        <MissionVision />
        <Audience />
        <AboutSections />
        <GoogleReviews />
        <News />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
